// src/components/ui/ContainerPadrao.jsx
export default function ContainerPadrao({ children, className = "" }) {
  return (
    <div
      className={`bg-white rounded-md shadow-md px-4 py-3 w-full h-full flex-1 overflow-visible ${className}`}
    >
      {children}
    </div>
  );
}
